import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PersonelService } from './personel.service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private service: PersonelService, private route: Router) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.service.getToken();
    if (token != null) {
      if (req.url.search("api/document/upload") !== -1) {
        //console.log("content type formdata");
        return next.handle(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }))
          .pipe(catchError(x => this.handleAuthError(x)));
      } else {
        return next.handle(req.clone({ setHeaders: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }))
          .pipe(catchError(x => this.handleAuthError(x)));
      }
    } else {
      return next.handle(req.clone({ setHeaders: { 'Content-Type': 'application/json' } }))
        .pipe(catchError(x => this.handleAuthError(x)));;
    }
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 401 || err.status === 403) {
      this.route.navigate(['/']);
      return of(err.message);
    }

    return throwError(err);
  }
}